import React from 'react';
import spinner from "../assets/svg/spinner.svg";

const Spinner = () => {
  return (
    <div className="bg-black bg-opacity-70 flex items-center justify-center fixed z-50 left-0 right-0 bottom-0 top-0">

        <div>
            <img className="h-24" src={spinner} alt="" />
        </div>
    
    
    </div>
  )
}

export default Spinner